const DEFAULT_DURATION = 5000;

const state = {
  items: [],
  nextId: 1,
};

const mutations = {
  REPLACE(state, toast) {
    state.items = [toast];
    state.nextId += 1;
  },
  REMOVE(state, id) {
    state.items = state.items.filter(t => t.id !== id);
  },
  CLEAR(state) {
    state.items = [];
  },
};

const actions = {
  show({commit, state, dispatch}, payload) {
    const id = state.nextId;
    const toast = {
      id,
      message: payload?.message || "",
      type: payload?.type || "error",
      action: payload?.action || null,
      duration:
        payload?.duration === 0
          ? 0
          : payload?.duration || DEFAULT_DURATION,
    };
    commit("REPLACE", toast);
    if (toast.duration > 0) {
      setTimeout(() => dispatch("dismiss", id), toast.duration);
    }
    return id;
  },
  dismiss({commit}, id) {
    commit("REMOVE", id);
  },
  clear({commit}) {
    commit("CLEAR");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
